import { List as AntList } from 'antd';
import { ListItemProps } from 'antd/lib/list/Item';
import React, { ReactNode } from 'react';

import { Meta } from './Meta';

const { Item: AntItem } = AntList;

export interface IItemProps extends React.FC<ListItemProps> {
  title?: ReactNode;
  Meta: typeof Meta;
}

/**
 * List.Item component
 */
export const Item: IItemProps = (props) => <AntItem {...props} />;

Item.Meta = Meta;
